import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import ReturnGoods from "../../../containers/modules/warehouse/return-goods";

export default function ReturnGoodsRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="return-goods"
      index
      element={
        <AccessControl
          name={"Return Goods List"}
          auth={authUser}
          component={() => <ReturnGoods authUser={authUser} />}
        />
      }
    />
  );
}
